// features/auth/hooks/use-auth-listener.ts
import * as Sentry from "@sentry/react";
import { useNavigate } from "@tanstack/react-router";
import { Hub } from "aws-amplify/utils";
import { useEffect } from "react";
import { authApi } from "../api/auth.api";
import { getCurrentUser as getUserFromApi } from "../api/user.api";
import { useAuthStore } from "../stores/auth.store";

export function useAuthListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", async ({ payload }) => {
      const { event } = payload;

      switch (event) {
        case "signedIn": {
          const [jwt, cognitoUser] = await Promise.all([
            authApi.getJwt(),
            authApi.getCurrentUser(),
          ]);
          useAuthStore.setState({ jwt, cognitoUser });
          
          if (jwt) {
            try {
              const currentUser = await getUserFromApi();
              useAuthStore.setState({ currentUser });
              Sentry.setUser({ id: currentUser.authId });
            } catch (error) {
              console.error("Failed to load user data:", error);
            }
          }
          
          navigate({ to: "/" });
          break;
        }

        case "signedOut": {
          useAuthStore.setState({
            jwt: undefined,
            cognitoUser: null,
            currentUser: null,
          });
          Sentry.setUser(null);
          navigate({ to: "/sign-in" });
          break;
        }

        case "tokenRefresh": {
          const jwt = await authApi.getJwt();
          useAuthStore.setState({ jwt });
          break;
        }

        case "tokenRefresh_failure": {
          useAuthStore.setState({
            jwt: undefined,
            cognitoUser: null,
            currentUser: null,
          });
          Sentry.setUser(null);
          navigate({ to: "/sign-in" });
          break;
        }
      }
    });

    return () => unsubscribe();
  }, [navigate]);
}
